<template>
    <div class="card-header">
        <div class="bg">
            <common-icon name="search-gray" size="large" class="header-search-layout"></common-icon>
            <input v-model="search" type="text" placeholder="Search Patient" class="search" @input="onSearchInput" />
        </div>
    </div>
</template>
<script>
    import debounce from 'lodash.debounce'
    import config from '../../../config'

    export default {
        data() {
            return {
                search: '',
            }
        },
        methods: {
            onSearchInput: debounce(function () {
                this.$emit('search', this.search)
            }, config.DEBOUNCE.DEFAULT),
        },
    }
</script>
<style scoped>
    .bg {
        display: flex;
        gap: 10px;
        position: relative;
        width: 100%;
    }

    .bg input {
        flex: 1;
        padding: 8px 29px;
        border-radius: 6px;
        border: 1px solid #f5f5f5;
        font-size: 12px;
        background-color: #f5f5f5;
        height: 51px;
        width: 100%;
    }

    .bg i {
        position: absolute;
        top: 15px;
        left: 7px;
    }
</style>
